import NetworkConfig from './network-config';

export default class NetworkUtils {
  static logRequestInfo(config, label = 'New Request') {
    if (NetworkConfig.isLogEnabled && false) {
      console.log(`%c>>> ${label} ${config.metadata.id}`, 'color: orange; font-weight: bold');
      console.log(`%c>>> %c${config.method.toUpperCase()} ${config.url}`, 'color: orange; font-weight: bold', 'color:white');
    }
  }

  static logResponseInfo(response, label = 'New Response') {
    if (NetworkConfig.isLogEnabled && false) {
      const status = response.status || response.response.status;
      const color = status === 200 ? 'lightgreen' : (status < 500 ? 'orange' : 'red');
      console.log(`%c<<< %c${label} ${response.config.metadata.id} (${response.duration}ms)`, 'color: yellow; font-weight: bold;', `color: ${color}; font-weight: bold`);
      console.log(`%c<<< %c${status} ${response.config.url}`, 'color: yellow; font-weight: bold', `color: ${color}; font-weight: bold`);
    }
  }
}



// WEBPACK FOOTER //
// ./src/network/network-utils.js